import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { Modal } from '../Modal/Modal';

type ConfirmRemoveDialogProps = { message: string; onClick: () => void; title?: string };

export function ConfirmRemoveDialog(props: ConfirmRemoveDialogProps) {
    const translate = useTranslate();
    const [isVisible, setIsVisible] = React.useState<boolean>(false);

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsVisible(true);
    };

    const handleConfirm = (e: React.MouseEvent) => {
        e.stopPropagation();
        props.onClick();
        setIsVisible(false);
    };

    const handleCancel = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsVisible(false);
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-default btn-xs ml5"
                style={{ float: 'right' }}
                onClick={(e) => {
                    handleDelete(e);
                }}
                title={props.title}
            >
                <i className="fa fa-trash-o"></i>
            </button>
            {isVisible && (
                <Modal id="confirm-dialog" classNames="confirm-dialog" closeOnBackdropClick={false}>
                    <Modal.Content isScrollBarVisible={false} style={{ height: '50px' }}>
                        <strong className="mt10">{props.message}</strong>
                    </Modal.Content>
                    <Modal.Actions>
                        <button className="btn btn-sm btn-default" onClick={(e) => handleCancel(e)}>
                            {translate('common.cancel')}
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={(e) => handleConfirm(e)}>
                            {translate('common.remove')}
                        </button>
                    </Modal.Actions>
                </Modal>
            )}
        </>
    );
}
